module.exports = __webpack_public_path__ + "static/img/LW_SRG_Blacklogo_powered@2x.a2ce1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/buyer-listing-details-as-pdf/assets/LW_SRG_Blacklogo_powered@2x.png
// module id = 2IYy
// module chunks = 0